export default {
  data() {
    return {
      pxToEmCache: {},
    };
  },
  computed: {
    emStyling() {
      let stylingSource = {};

      if (this.widget) {
        // Widget context
        stylingSource = this.widget.styling;
      } else if (this.component) {
        // Component context
        const componentStyles = this.component.styling || {};
        const usesThemeStyles = this.component.settings?.usesThemeStyles ?? false;

        if (usesThemeStyles && this.theme) {
          const themeStyles = this.theme || {};
          // Merge theme styles with component styles, giving precedence to component styles
          stylingSource = {  ...componentStyles, ...themeStyles };
        } else {
          stylingSource = { ...componentStyles };
        }
      }

      // Convert pixel values to em units
      return Object.keys(stylingSource).reduce((acc, key) => {
        const value = stylingSource[key];
        acc[key] =
          typeof value === 'string' && value.includes('px')
            ? this.pxToEm(value)
            : value;
        return acc;
      }, {});
    },
  },
  methods: {
    pxToEm(pxValue) {
      // Check if the value is already in the cache
      if (this.pxToEmCache[pxValue]) {
        return this.pxToEmCache[pxValue];
      }

      const numericPxValue = parseFloat(pxValue);
      const result = `${numericPxValue / 16}em`;

      // Store the result in the cache before returning it
      this.pxToEmCache[pxValue] = result;
      return result;
    },
  },
};
